export const SERVER = 'server'
export const MODAL_IFRAME_ID = 'checkout-modal'
export const MODAL = 'modal'
